module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-next-2fca9e23b11d535b8e838a4ef47e288b.svg";